import React, { useRef, useCallback, useEffect, useState } from 'react';
import "./modalVideo.css";
import iconoCompartir from "../../assets/imgs/detalle_blog/share-white.svg";
import iconoX from "../../assets/imgs/detalle_blog/logo-x.svg";
import iconoFacebook from "../../assets/imgs/detalle_blog/Asset_Facebook-normal.svg";
import iconoLinkedIn from "../../assets/imgs/detalle_blog/LinkedIn.svg";
import iconoMail from "../../assets/imgs/detalle_blog/Asset_Mail-Normalblanco.svg";
import iconoCopiar from "../../assets/imgs/detalle_blog/Link.svg";

const ModalVideo = ({ isOpen, closeModal, urlVideo, id_idea, titulo }) => {

  const handleX = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        "https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea
      )}&text=${encodeURIComponent("Idea en corto")}`,
      "_blank"
    );
  };

  const handleFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea)}`,
      "_blank"
    );
  };

  const handleLinkedIn = (e) => {
    window.open(
      `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
        "https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea
      )}&title=${encodeURIComponent("Idea en corto")}`,
      "_blank"
    );
  };

  const handleMail = () => {
    window.location.href = `mailto:?subject=${encodeURIComponent(
      "Idea en corto"
    )}&body=${encodeURIComponent("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea)}`;
  };

  const handleCopiarURL = () => {
    navigator.clipboard.writeText("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea).then(() => {
      alert('¡Enlace copiado al portapapeles!');
    }).catch((error) => {
      console.error('Error al copiar al portapapeles:', error);
    });
  };




  const [shareOpen, setShareOpen] = useState(false);

  const shareRef = useRef(null);
  const triggerRef = useRef(null);

  if (!isOpen) return null;

  return (
    <>
      <div className="_ngcontent-ng-c485834739 _nghost-ng-c798911410">

        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="video-modal-title"
          className="video-modal"
        >

          <section className="video-modal__panel video-modal__panel_youtube_on">

            <button
              type="button"
              aria-label="Cerrar video"
              onClick={closeModal}
              className="video-modal__close"
            >
              ✕
            </button>

            {/* <header className="video-modal__header">
              <h2 id="video-modal-title" className="video-modal__title">
                Video
              </h2>
            </header>*/}

            <div className="video-modal__body">

              <div className="video-modal__content">

                <div className="video-modal__player-frame">

                  <iframe
                    className="video-modal__player"
                    src={urlVideo}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />

                </div>

              </div>

            </div>

            <div className="div-compartir-idea-v">

              {/* SHARE */}

              <span className="click-tooltip">

                <span
                  tabIndex="0"
                  role="button"
                  className="click-tooltip__trigger"
                  aria-expanded={shareOpen}
                  ref={triggerRef}
                  onClick={() => setShareOpen(prev => !prev)}
                >

                  <div className="post-actions__group post-actions__group--share library-btn-share">

                    <img
                      src="/assets/img2026/icon_share.svg"
                      alt="Compartir en redes"
                      aria-hidden="true"
                      className="post-actions__icon post-actions__icon--share"
                    />

                    <span className="post-actions__share-link">
                      Compartir
                    </span>

                  </div>

                </span>

                {shareOpen && (

                  <span
                    className="click-tooltip__panel"
                    onClick={(e) => e.stopPropagation()}
                    ref={shareRef}
                  >

                    <span role="tooltip" className="up-arrow click-tooltip__content">

                      <span className="click-tooltip__actions">

                        <button
                          type="button"
                          aria-label="Compartir en X"
                          className="click-tooltip__action"
                          onClick={handleX}
                        >
                          <img
                            src="/assets/img2026/logo_twitter.svg"
                            alt="Compartir en X"
                            className="click-tooltip__icon click-tooltip__icon--x"
                          />
                        </button>

                        <button
                          type="button"
                          aria-label="Compartir en Facebook"
                          className="click-tooltip__action"
                          onClick={handleFacebook}
                        >
                          <img
                            src="/assets/img2026/logo_facebook.svg"
                            alt="Compartir en Facebook"
                            className="click-tooltip__icon click-tooltip__icon--facebook"
                          />
                        </button>

                        <button
                          type="button"
                          aria-label="Compartir por email"
                          className="click-tooltip__action"
                          onClick={handleMail}
                        >
                          <img
                            src="/assets/img2026/icon_email.svg"
                            alt="Compartir por email"
                            aria-hidden="true"
                            className="click-tooltip__icon click-tooltip__icon--email"
                          />
                        </button>

                        <button
                          type="button"
                          aria-label="Compartir en LinkedIn"
                          className="click-tooltip__action"
                          onClick={handleLinkedIn}
                        >
                          <img
                            src="/assets/img2026/linkedin.svg"
                            alt="Compartir en LinkedIn"
                            className="click-tooltip__icon click-tooltip__icon--linkedin"
                          />
                        </button>

                        <button
                          type="button"
                          aria-label="Copiar liga"
                          className="click-tooltip__action"
                          onClick={handleCopiarURL}
                        >
                          <img
                            src="/assets/img2026/share.svg"
                            alt="Copiar enlace"
                            className="click-tooltip__icon click-tooltip__icon--share"
                          />
                        </button>

                      </span>

                    </span>

                  </span>

                )}

              </span>

            </div>

          </section>

        </div>

      </div>
    </>
  );
};
export default ModalVideo;